<template>
    <section v-editable="blok" class="multi-column-cards">
        <div class="container">
            <div class="cards">
                <template v-for="helpTile in blok.helpTiles" :key="helpTile._uid">
                    <Component :is="helpTile.component" :blok="helpTile" />
                </template>
            </div>
            <hr />
        </div>
    </section>
</template>

<script setup lang="ts">
import type { IL4HelpTilesGrid } from '~/types/components/L4HelpTilesGrid';

defineProps<{ blok: IL4HelpTilesGrid }>();
</script>

<style lang="postcss" scoped>
.multi-column-cards {
    @apply flex justify-center pt-8;

    .container {
        @apply md:px-4 py-0;
        .cards {
            @apply justify-center grid grid-cols-[repeat(3,1fr)] md:gap-[16px_16px] px-0 pb-4;
        }
        hr {
            @apply border-t-[#dfdfdf] border-t border-solid;
        }
    }
}

@media (max-width: 1050px) {
    .multi-column-cards {
        .container {
            .cards {
                @apply grid-cols-[repeat(3,minmax(auto,300px))];
            }
        }
    }
}

@media (max-width: 992px) {
    .multi-column-cards {
        .container {
            .cards {
                @apply grid-cols-[repeat(2,minmax(auto,1fr))];
            }
        }
    }
}

@media (max-width: 768px) {
    .multi-column-cards {
        .container {
            .cards {
                @apply grid-cols-[repeat(1,minmax(100%,100%))];
                :deep(.wrapper) {
                    @apply max-w-[100%];
                }
            }
        }
    }
}
</style>
